
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'app-dam-preview-text',
  templateUrl: './dam-preview-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamPreviewTextComponent  implements OnInit {
  @Input() text: string;
  constructor(protected ref: NbDialogRef<DamPreviewTextComponent>) {

  }

  ngOnInit(): void {
    this.text = this.text.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }

  dismiss(confirmed: boolean) {
    this.ref.close(confirmed);
  }


}
